export class Product {
    photoUrl: String;
    name: String;
    price: Number;
    descrition: String;
    disponibility: boolean;
    lowerCase: String;
}
